import { Outlet } from 'react-router-dom';

import './UnauthenticatedLayout.css';

export const UnauthenticatedLayout = () => {
  return (
    <>
      <div className="unauthenticated-layout">
        <main>
          <div className="unauthenticated-layout__page">
            <Outlet />
          </div>
        </main>
      </div>
    </>
  );
};
